type SearchOptionsCreateEntity = {
  type: 'createEntity';
};

type SearchOptionsChildren = {
  type: 'children' | 'childrenSearch' | 'currentEntity';
  entityId?: string;
};

type SearchOptionsGlobal = {
  type: 'global';
};

export type SearchOptions =
  | SearchOptionsCreateEntity
  | SearchOptionsChildren
  | SearchOptionsGlobal;

export type SearchQuery = {
  rawQuery: string;
  queryText: string;
  queryOptions: SearchOptions;
};

export function preprocessQuery(query: string | null): string {
  if (!query) {
    return '';
  }

  if (query.startsWith('@@')) {
    if (query[2] !== ' ' && query.length >= 3) {
      return '@@ ' + query.slice(2);
    }
  }

  return query;
}

export function processQuery(query: string | null): SearchQuery {
  let queryText = query || '';
  let queryOptions: SearchQuery['queryOptions'] = { type: 'global' };

  if (query?.[0] === '@') {
    if (query[1] === '@') {
      queryOptions = { type: 'currentEntity' };
      queryText = query.slice(3);
    } else if (query[1] == '<') {
      queryOptions = { type: 'children' };
      const closingIndex = query.indexOf('>');
      if (closingIndex !== -1) {
        const entityId = query.slice(2, closingIndex).trim();
        if (entityId.length === 36) {
          queryOptions.entityId = entityId;
          queryText = query.slice(closingIndex + 1).trimStart();
        } else {
          queryText = '';
        }
      } else {
        queryText = '';
      }
    } else {
      queryOptions = { type: 'childrenSearch' };
      queryText = query.slice(1).trim();
    }
  }

  queryText = queryText.replaceAll('\\@', '@');
  queryText = queryText.replaceAll('\\+', '+');

  return {
    rawQuery: query || '',
    queryText: queryText,
    queryOptions,
  };
}

export function rebuildQuery(searchQuery: SearchQuery): string {
  const { queryText, queryOptions } = searchQuery;

  let prefix = '';

  if (queryOptions.type === 'createEntity') {
    prefix = '+';
  } else if (queryOptions.type === 'currentEntity') {
    prefix = '@@ ';
  } else if (queryOptions.type === 'children') {
    if (queryOptions.entityId) {
      prefix = `@<${queryOptions.entityId}> `;
    } else {
      prefix = '@<> ';
    }
  } else if (queryOptions.type === 'childrenSearch') {
    prefix = '';
  }

  // Escape @ and + in the query text
  const escapedText = queryText;

  return prefix + escapedText;
}
